// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1pWMd","filesListContainer":"PosDisputesFiles_filesListContainer__3EQpx","filesButton":"PosDisputesFiles_filesButton__2JHGE"};